export enum SLICE_NAMES {
	USUARIO = "USUARIO",
	EVALUACIONES = "EVALUACIONES",
	ENTIDADES = "ENTIDADES",
}
